import type { JSONSchema7 } from "json-schema"

export type SuperTaskParametersModel = {
    [key: string]: any
}

export enum SuperTaskWorkerType {
    AI = "ai",
    BOTS = "bots",
    COLLABORATORS = "collaborators",
    CROWD = "crowd",
    IDEMPOTENT = "idempotent"
}

export type SuperTaskWorkerModel = {
    type: SuperTaskWorkerType
    name: string
    description: string
    active: boolean
    timeout: number
    numTasks: number
    onTimeout: {
        action: string
        maxRetries: number
    }
    confidenceThreshold: number
}

export type SuperTaskModel = {
    parameters: SuperTaskParametersModel
    parametersSchema: JSONSchema7
    superTaskWorkflow: string
    workers: SuperTaskWorkerModel[]
    workersSchema: JSONSchema7
    editable: boolean
}
